(() => {
  const endpoint='https://avis-montrose-medias.curly-band-934d.workers.dev';
  const marker=/\[MONTROSE-MEDIA:([0-9a-f-]{36})\]/i;
  const observed=new WeakSet();
  function scan(scope=document){
    scope.querySelectorAll('.mpav__card blockquote,.mhav__texte,.mon-ra__review blockquote').forEach(quote=>{
      const match=marker.exec(quote.textContent);
      const id=match?.[1]||quote.dataset.monMedia;
      if(!id||observed.has(quote))return;observed.add(quote);
      quote.dataset.monMedia=id;
      if(quote.nextElementSibling?.classList.contains('mon-avis-medias'))return;
      if(match){const clean=quote.textContent.slice(0,match.index).trim().replace(/^«\s*/,'').replace(/\s*»$/,'');quote.textContent='« '+clean+' »';}quote.removeAttribute('title');
      // These new submissions do not independently prove a purchase.
      const card=quote.closest('.mpav__card,.mhav__carte,.mon-ra__review');
      card?.querySelectorAll('.mpav__verified,.mhav__verifie').forEach(badge=>badge.remove());
      fetch(endpoint+'/avis/'+id,{headers:{Accept:'application/json'}}).then(async response=>{
        if(!response.ok)return;const data=await response.json();
        if(!data.ok||!data.avis?.medias?.length||!quote.isConnected)return;
        const gallery=document.createElement('div');gallery.className='mon-avis-medias';gallery.setAttribute('aria-label','Pièces jointes à cet avis');
        data.avis.medias.forEach((media,index)=>{
          const url=new URL(media.url);if(url.origin!==endpoint||!url.pathname.startsWith('/media/'))return;
          if(media.kind==='image'){
            const link=document.createElement('a');link.href=url.href;link.target='_blank';link.rel='noopener';link.setAttribute('aria-label','Ouvrir la photo '+(index+1));
            const image=document.createElement('img');image.src=url.href;image.alt='Photo jointe à l’avis de '+data.avis.prenom;image.width=media.width;image.height=media.height;image.loading='lazy';link.append(image);gallery.append(link);
          }else if(media.kind==='video'){
            const video=document.createElement('video');video.src=url.href;video.controls=true;video.playsInline=true;video.preload='metadata';video.setAttribute('aria-label','Vidéo jointe à cet avis');gallery.append(video);
          }
        });
        quote.after(gallery);
      }).catch(()=>{});
    });
  }
  scan();
  const observer=new MutationObserver(records=>{if(records.some(record=>record.addedNodes.length))scan();});
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',()=>scan());
})();
